import { SET_APLCATL, SET_AUTH_EXTERNAL, SET_CALL_BACK_PARAM, SET_TRANSACTION_ID, SET_USER_INFO } from './mutations';
import router from '@/router/index';
import { getLogout } from '@/apis/login.js';

export const actions = {
    setTransactionId({ commit }, payload) {
        if (!payload) {
            payload = '';
        }
        commit(SET_TRANSACTION_ID, payload);
    },
    resetTransactionId({ commit }) {
        commit(SET_TRANSACTION_ID, '');
    },
    setAuthExternal({ commit }, payload) {
        commit(SET_AUTH_EXTERNAL, payload);
    },
    setUserInfo({ commit }, payload) {
        commit(SET_USER_INFO, payload);
    },
    clearAll({
        commit,
        dispatch,
    }) {
        commit(SET_AUTH_EXTERNAL, 'N');
        commit(SET_USER_INFO, {});
        commit(SET_APLCATL, '');
        dispatch('resetTransactionId');
        dispatch('eNotify/clearMember', null, { root: true });
        dispatch('eNotify/clearOverYearOtp', null, { root: true });
        dispatch('policy/resetChangeItemsResult', null, { root: true });
    },
    goFubonOfficial({ dispatch }) {
        getLogout();
        dispatch('clearAll');
        window.location = process.env.VUE_APP_FUBON_WEBSITE;
    },
    clearAndGoPage({ dispatch }, page) {
        getLogout();
        dispatch('clearAll');
        if (page) {
            router.push({ name: page });
        }
    },
    setAplCatl({ commit }, payload) {
        commit(SET_APLCATL, payload);
    },
    goCallBackUrl({ dispatch }, payload) {
        getLogout();
        dispatch('clearAll');
        window.location = payload;
    },
    setCallBackParam({ commit }, payload) {
        commit(SET_CALL_BACK_PARAM, payload);
    },
};
